<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="12.44mm"
		height="12.43mm"
		viewBox="0 0 35.25 35.24"
	>
		<defs>
			<clipPath id="clip-path" transform="translate(-1.35 -1.42)">
				<rect width="36.77" height="36.77" fill="none" />
			</clipPath>
		</defs>

		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<g clip-path="url(#clip-path)">
					<path
						d="M24.17,26.6A14.09,14.09,0,0,1,4.58,24.44,14.08,14.08,0,0,1,24.37,4.6a14.12,14.12,0,0,1,2.25,19.56l.52.55,8.78,8.78a1.8,1.8,0,0,1,.6,2,1.69,1.69,0,0,1-1.35,1.18,1.86,1.86,0,0,1-1.74-.68l-8.72-8.73c-.18-.18-.33-.4-.51-.61m1.87-11A10.64,10.64,0,0,0,15.52,4.9,10.77,10.77,0,0,0,4.84,15.45,10.77,10.77,0,0,0,15.4,26.13,10.64,10.64,0,0,0,26,15.57"
						transform="translate(-1.35 -1.42)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</svg>
</template>
